import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "../../utils/utils";

export const fetchEvent = createAsyncThunk(
  "fetchEvent",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/event/list.php?page=" +
      data.page +
      "&limit=" +
      data.limit;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchEventSearch = createAsyncThunk(
  "fetchEventSearch",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/event/search.php?search=" +
      data;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.event;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchEventEdit = createAsyncThunk(
  "fetchEventEdit",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/event/details.php?id=" +
      data.id;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.event[0];
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const saveEvent = createAsyncThunk(
  "saveEvent",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/event/create.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.event) return result.data.event;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const editEvent = createAsyncThunk(
  "editEvent",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/event/update.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.event) return result.data.event;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const deleteEvent = createAsyncThunk(
  "deleteEvent",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/event/delete.php?id=" + id;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.status) {
          return result.status;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
